<i class="fa-lg fa-folder fa-fw" [ngClass]="getClass()"></i>